import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataShareService {
  
  dataShareOfProductsSelection: BehaviorSubject<any> = new BehaviorSubject(null);
  dataShareOfProductsSelection$ = this.dataShareOfProductsSelection.asObservable();

  switchBetweenProducts: BehaviorSubject<any> = new BehaviorSubject(null);
  switchBetweenProducts$ = this.switchBetweenProducts.asObservable();

  productRadioChecked: BehaviorSubject<any> = new BehaviorSubject(null);
  productRadioChecked$ = this.productRadioChecked.asObservable();

  constructor() { }

  emitDataShareOfProductsSelection(change: any) {
    this.dataShareOfProductsSelection.next(change);
  }

  emitDataBetweenProducts(change: any) {
    this.switchBetweenProducts.next(change);
  }

  emitDataProductRadioChecked(change: any) {
    this.switchBetweenProducts.next(change);
  }
}
